<script setup>
  import privacyPolicy from '@/assets/cmp/policy/policy.pdf'
  import termsOfUse from '@/assets/cmp/policy/oferta.pdf'

  const props = defineProps({
    transparent: {
      type: Boolean
    }
  })
</script>

<template>
  <div id="policy">
    <div class="cmp-policy" :class="{ transparent: props.transparent }">
      <div class="policy-title">{{text('policy.title')}}</div>
      <div class="cmp-support-info">
        <div>
          <b>CONNECTGROUP DWC-LLC</b>
        </div>
        <div>
          Address: Dubai South Central Business Center, Mailbox: 712448, <br/>Dubai - UAE
        </div>
        <div class="email">
          email: <a href="mailto:info@walletcg.com">info@walletcg.com</a>
        </div>
      </div>
      <div class="cmp-links">
        <a target="_blank" :href="privacyPolicy">Privacy Policy</a>
        <a target="_blank" :href="termsOfUse">Terms of Use</a>
      </div>
    </div>
  </div>

</template>

<style scoped lang="scss">
  .cmp-policy {
    border-radius: 16px;
    background: var(--element-bg);
    padding: 16px;

    .policy-title {
      margin-bottom: 25px;
      font-weight: bold;
      font-size: 18px;
    }
    .cmp-support-info {
      display: flex;
      flex-direction: column;
      gap: 8px;
      font-size: 14px;
      color: var(--text-color-secondary);

      .email {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
    .cmp-links {
      display: flex;
      align-items: center;
      gap: 12px;

      font-size: 12px;
      margin-top: 16px;
    }

    &.transparent {
      border-radius: 0;
      background: transparent;
      padding: 0;

      .policy-title {
        display: none;
      }
    }
  }

</style>
